import Select from "../../components/Select/Select";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";

const ParentRequestFilter = ({ fetchParentRequests, status, setStatus, id_number, setIdNumber }) => {
  return (
    <div className="row mb-3">
      <div className="col-md-5">
        <Select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="mt-3"
          options={[
            { name: "Pending", id: "pending" },
            { name: "Approved", id: "approved" },
            { name: "Rejected", id: "rejected" },
          ]}
        ></Select>
      </div>
      <div className="col-md-5">
        <Input
          name="id_number"
          className="mt-3"
          placeholder="Search by admission number"
          value={id_number}
          onChangeHandler={(e) => setIdNumber(e.target.value)}
        />
      </div>
      <div className="col-md-2 mt-3">
        <Button onClick={fetchParentRequests}>Search</Button>
      </div>
    </div>
  );
};

export default ParentRequestFilter;
